import { omit } from 'lodash';
import { FC, useRef } from 'react';
import { emitGAEvent, GA_EVENT } from '../../../utils/ga-event-helpers';

interface ButtonProps {
	isLink?: boolean;
	children?: React.ReactNode;
	className: string;
	title?: string;
	id?: string;
	href?: string;
	uid?: string;
	imid?: string;
	onClick?: (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
}

const Button: FC<ButtonProps> = (props) => {
	const { isLink, children, id, uid, imid, onClick } = props;

	const buttonRef = useRef<HTMLButtonElement>(null);
	const linkRef = useRef<HTMLAnchorElement>(null);


	const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
		// Build userId safely so absent uid/imid never produce the literal "undefinedundefined"/"nullnull".
		const userId = [uid, imid].filter(Boolean).join('') || undefined;
		const payload: Record<string, string> = {};
		if (id) payload.buttonName = id;
		if (userId) payload.userId = userId;
		emitGAEvent(GA_EVENT.BUTTON_CLICK, payload);
		if (onClick) {
			onClick(e);
		}
	};

	const propsWithoutIsLink = omit(props, ['isLink', 'onClick']);

	return isLink ? (
		<a onClick={handleClick} ref={linkRef} {...propsWithoutIsLink}>
			{children}
		</a>
	) : (
		<button onClick={handleClick} ref={buttonRef} {...propsWithoutIsLink}>
			{children}
		</button>
	);
};

export default Button;
